/**
 * Message when user complete filling informations
 *
 * @param onBackHome
 * @returns {JSX.Element}
 * @constructor
 */
const MessageStatus = ({onBackHome}) => {


	const message = `<p> <strong>Votre demande a bien été transmise au service de Gestion des Volontés.</strong></p>
        <p> Vous recevrez dans les prochains jours par voie postale à l’adresse indiquée votre recueil des volontés à compléter et à renvoyer à l’adresse suivante:</p>
       <p><strong>17 rue de l’arrivée  75015 PARIS</strong></p>
       <p><strong>Service de Gestion des Volontés</strong></p>
                `

	return <>

		<div dangerouslySetInnerHTML={{__html: message}} className="card-body"></div>


		<div className="flex space-around middle">
			<button onClick={onBackHome} type='button' title="Revenir sur la page d’accueil"
					className="bouton bouton-full bouton-primary ">
				<span className="text">Revenir sur la page d’accueil</span>
			</button>
		</div>


	</>
}

export default MessageStatus;
